import Cookies from "js-cookie";
const query = new URLSearchParams(window.location.search);
const subdomainParams = query.get('subdomain');
const subdomainCookies = Cookies.get('lynkaz_workflow');

const getEnv = (key) => {
    return (process.env[key] || "").trim();
};

const commonHost = getEnv("REACT_APP_COMMON_HOST");

let Settings = {
    baseUrl: getEnv("REACT_APP_API_WORKFLOW_URL") + '/',
    apiWorkflowUrl: getEnv("REACT_APP_API_WORKFLOW_URL"),
    apiBaseUrl: getEnv("REACT_APP_API_BASE_URL"), // assets
    loginUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${commonHost}`,
    apiUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${commonHost}`,
    apiOrgUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_ORG_HOST")}`,
    apiVendorUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_VENDOR_HOST")}`,
    apiItemUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_ITEM_HOST")}`,
    apiPurchaseOrderUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_PO_HOST")}`,
    apiProcurementSettingsUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_CONFIG_HOST")}`,
    apiPurchaseRequisitionUrl: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_PR_HOST")}`,
    apiUrls: {
        segments: `https://${subdomainParams ? subdomainParams : subdomainCookies}.${getEnv("REACT_APP_FINANCIALS_HOST")}`
    },
    defaultLang: 'en',
    userTokenKey: 'lynkaq_user_token',
    subdomainKey: 'lynkaz_workflow',
    dateFormateKey: 'lynkaq_dateformate',
    languageKey: 'app_lang',
    userTokenExpireDate: 1,
    redirectUrlAfterLogin: 'workflow',
    loginLink: 'login',
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    debug: true,
    defaultDateFormate: 'mm/dd/yyyy',
    dropdownPageSize:10,
    source_id: {
        tenant: 1, warehouse: 4, site: 3, entity: 2, address: 5, vendor: 6, vendor_registration: 7, bank: 8
    },
    workflow_documents_sources: [ // these are the id's of sources on which workflow is implemented
        6, 12, 13, 15, 14, 9, 10, 11, 16, 77, 78, 79, 54, 87, 86, 91, 94, 95, 98, 101, 102, 103, 97, 65, 109, 112, 113
    ],
    enum_workflow_data: {
        instance_state: [
            {
                label: 'All',
                value: 'all'
            },
            {
                label: 'Completed',
                value: 'completed'
            },
            {
                label: 'In Completed',
                value: 'incompleted'
            }
        ],
        task_types_recall: {
           id: 6,
           name: 'Recall'
        },
        task_types_reassign: {
           id: 12,
           name: 'Task Re-assign'
        },
    },
    fieldTypeList: [
        { value: 1, label: 'String' },
        { value: 2, label: 'Number' },
        { value: 3, label: 'Boolean' },
        { value: 4, label: 'Date & Time' }
    ],
    apiHttpMethods: [
        { value: 'GET', label: 'GET' },
        { value: 'POST', label: 'POST' },
        { value: 'PUT', label: 'PUT' },
        { value: 'PATCH', label: 'PATCH' },
        { value: 'DELETE', label: 'DELETE' },
    ],
    havingData: [
        { value: 'False', label: 'False' },
        { value: 'True', label: 'True' }
    ],
    operatorData: [
        { value: 1, label: "equals to" },
        { value: 2, label: "not equals to" },
        { value: 3, label: "less than" },
        { value: 4, label: "greater than" },
        { value: 5, label: "less than equals to" },
        { value: 6, label: "greater than equals to" },
        { value: 7, label: "starts with" },
        { value: 8, label: "ends with" },
        { value: 9, label: "like" }
    ],
    conditionData: [
        { value: 1, label: 'Where' },
        { value: 2, label: 'AND' },
        { value: 3, label: 'OR' }
    ],
    validator: {
        max: {
            code: 10,
            name: 80
        }
    }
}
export default Settings;
